var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMultiLine = function SvgMultiLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "multi-line-text")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545d6b",
    d: "M0 0h34.133v32h-34.133v-32zM3.2 3.2v25.6h27.733v-25.6h-27.733zM8.533 8.533h17.067v2.133h-17.067v-2.133zM8.533 14.933h17.067v2.133h-17.067v-2.133zM8.533 21.333h17.067v2.133h-17.067v-2.133z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultiLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multi-line.9734ff25.svg";
export { ForwardRef as ReactComponent };